import API from './API'
import {
  CATALOGUE_API, FLORIST_CATALOGS_API,
  ITEMS_PER_PAGE_CATALOGUE
} from '../constants/Constants'

function getProductBySearch(search, country) {
  return API({
    name: 'références',
    method: 'get',
    url: `${CATALOGUE_API}/search-by-reference-or-libcompo?keyword=${search}&orderBy=libcompo&way=asc&country=${country}`,
  })
}

function getNotMourningCatalogue(
    search,
    searchType,
    sortCatalog,
    sortType,
    sortOrder,
    currentPage
) {
  return {
    name: 'produits',
    method: 'get',
    url: `${CATALOGUE_API}/not-mournings/all?pagination=true${
        search ? `&${searchType}=${search}` : ''
    }${
        sortCatalog ? `&category=${sortCatalog}` : ''
    }&order%5B${sortType}%5D=${sortOrder}&page=${currentPage}&itemsPerPage=${ITEMS_PER_PAGE_CATALOGUE}`,
    headers: {
      accept: 'application/ld+json',
    },
  }
}

function getCatalogsByFlorist() {
  return {
    name: 'get_florist_catalogs',
    method: 'get',
    url: `${FLORIST_CATALOGS_API}`
  }
}

function getAvailableDatesByProduct(productId, country) {
  return API({
    name: 'available_dates',
    method: 'get',
    url: `${CATALOGUE_API}/available/${productId}/${country}`
  })
}

export default {
  getProductBySearch,
  getNotMourningCatalogue,
  getCatalogsByFlorist,
  getAvailableDatesByProduct
}
